import { LockKeyhole, LogIn } from "lucide-react";
import { Link } from "react-router-dom";

export default function PortalLogin({ authError, onSignIn }) {
  return (
    <main className="portal-state" data-testid="portal-login">
      <span className="eyebrow">GAMEDAY Holdings LLC</span>
      <LockKeyhole size={34} />
      <h1>INVESTOR PORTAL</h1>
      <p>
        Approved users can review confidential documents and development materials in a
        controlled environment.
      </p>
      {authError && <p className="portal-auth-error" data-testid="portal-auth-error">{authError}</p>}
      <button className="button button--red" onClick={onSignIn} data-testid="portal-google-login-button">
        <LogIn size={17} />
        Sign in with Google
      </button>
      <Link className="text-button" to="/investment" data-testid="portal-request-access-link">
        Request access first
      </Link>
      <Link className="text-button" to="/admin-login" data-testid="portal-admin-login-link">
        Administrator sign-in
      </Link>
    </main>
  );
}